import { createSelector } from 'reselect';
import type { RootState } from '@/redux/types';

export const getLogged = createSelector(
  (state: RootState) => state.auth,
  (auth) => !!auth.accessToken
);

export const getAccessToken = createSelector(
  (state: RootState) => state.auth,
  (auth) => auth.accessToken
);

export const getRefreshToken = createSelector(
  (state: RootState) => state.auth,
  (auth) => auth.refreshToken
);

export const getAccessExpiration = createSelector(
  (state: RootState) => state.auth,
  (auth) => auth.accessExpiresAt
);

export const getRefreshExpiration = createSelector(
  (state: RootState) => state.auth,
  (auth) => auth.refreshExpiresAt
);
